
<div>
    <div class="measure-label primary--text">
        {{ label }}
    </div>
    <div class="measure-text ro-background pa-2">
        {{ text }}
    </div>
</div>
